import { render, staticRenderFns } from "./top.vue?vue&type=template&id=c1c801f0&scoped=true"
var script = {}
import style0 from "./top.vue?vue&type=style&index=0&id=c1c801f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c801f0",
  null
  
)

export default component.exports